
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const FireEquipmentPage = () => {
  const products = [
    {
      name: 'Yangın Dolapları',
      description: 'İç mekan ve dış mekan yangın dolapları, çeşitli boyut ve modellerde',
      icon: 'ri-door-open-line',
    },
    {
      name: 'Yangın Hortumları',
      description: 'Yüksek basınca dayanıklı, çeşitli uzunluk ve çaplarda yangın hortumları',
      icon: 'ri-water-flash-line',
    },
    {
      name: 'Yangın Muslukları',
      description: 'İç ve dış mekan yangın muslukları, hidrant sistemleri',
      icon: 'ri-drop-line',
    },
    {
      name: 'Yangın Uyarı Levhaları',
      description: 'Fosforlu ve reflektif yangın güvenlik levhaları, yönlendirme işaretleri',
      icon: 'ri-error-warning-line',
    },
    {
      name: 'Yangın Battaniyeleri',
      description: 'Yağ ve elektrik yangınları için özel yangın battaniyeleri',
      icon: 'ri-shield-line',
    },
    {
      name: 'Duman Dedektörleri',
      description: 'Kablosuz ve kablolu duman algılama sistemleri',
      icon: 'ri-alarm-warning-line',
    },
  ];

  const faqs = [
    {
      question: 'Yangın söndürme ekipmanları nelerdir?',
      answer: 'Yangın söndürme ekipmanları; yangın tüpleri, yangın dolapları, hortumlar, musluklar, uyarı levhaları, yangın battaniyeleri, duman dedektörleri ve diğer yangın güvenlik malzemelerini kapsar.',
    },
    {
      question: 'Yangın dolabı zorunlu mu?',
      answer: 'Evet, belirli büyüklükteki işyerleri, apartmanlar ve kamu binalarında yangın dolabı bulundurma zorunluluğu vardır. Yangın yönetmeliğine göre gerekli sayıda yangın dolabı bulundurulmalıdır.',
    },
    {
      question: 'Yangın ekipmanları fiyatları nedir?',
      answer: 'Fiyatlar ürün tipine, boyutuna ve özelliklerine göre değişiklik gösterir. Toplu alımlarda özel indirimler sunuyoruz. Detaylı fiyat teklifi için bizimle iletişime geçebilirsiniz.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Yangın Söndürme Ekipmanları
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Yangın güvenliği için ihtiyacınız olan tüm ekipmanlar ve malzemeler
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="font-display font-bold text-3xl text-dark-900 mb-6">
              Yangın Söndürme Ekipmanları Satışı
            </h2>
            <p className="text-dark-600 leading-relaxed mb-6">
              İpek Yangın Söndürme olarak, yangın güvenliği için gerekli tüm <strong>yangın söndürme ekipmanları</strong> satışını gerçekleştiriyoruz. Yangın dolapları, hortumlar, musluklar, uyarı levhaları ve diğer tüm yangın güvenlik malzemelerini kaliteli ve uygun fiyatlarla sunuyoruz.
            </p>
            <p className="text-dark-600 leading-relaxed mb-12">
              Tüm ürünlerimiz TSE standartlarına uygun, sertifikalı ve uzun ömürlüdür. İşletmenizin veya binanızın ihtiyacına göre en uygun ekipmanları seçmenizde size yardımcı oluyoruz.
            </p>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-8">
              Ürün Kategorilerimiz
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {products.map((product, index) => (
              <div key={index} className="bg-white border-2 border-dark-100 rounded-xl p-6 hover:border-primary-500 hover:shadow-lg transition-all">
                <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${product.icon} text-3xl text-primary-600`}></i>
                </div>
                <h4 className="font-display font-semibold text-xl text-dark-900 mb-3">
                  {product.name}
                </h4>
                <p className="text-dark-600">
                  {product.description}
                </p>
              </div>
            ))}
          </div>

          <div className="prose prose-lg max-w-none">
            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4 mt-12">
              Yangın Dolapları
            </h3>
            <p className="text-dark-600 leading-relaxed mb-6">
              Yangın dolapları, yangın söndürme ekipmanlarının güvenli ve düzenli şekilde saklanması için kullanılır. İç mekan ve dış mekan modelleri, çeşitli boyutlarda ve cam veya metal kapak seçenekleriyle sunuyoruz.
            </p>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Yangın Hortumları ve Muslukları
            </h3>
            <p className="text-dark-600 leading-relaxed mb-6">
              Yüksek basınca dayanıklı yangın hortumları ve muslukları, büyük yangınlarda etkili müdahale için gereklidir. Çeşitli uzunluk ve çaplarda, kaliteli malzemeden üretilmiş ürünler sunuyoruz.
            </p>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Yangın Uyarı Levhaları
            </h3>
            <p className="text-dark-600 leading-relaxed mb-6">
              Fosforlu ve reflektif yangın güvenlik levhaları, acil çıkış yönlendirmeleri, yangın tüpü işaretleri ve diğer tüm güvenlik levhalarını sunuyoruz. Yasal gerekliliklere tam uyumlu ürünler.
            </p>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Kimler İçin Uygun?
            </h3>
            <ul className="list-disc list-inside space-y-2 text-dark-600 mb-8">
              <li>Ofisler ve iş merkezleri</li>
              <li>Fabrikalar ve üretim tesisleri</li>
              <li>Alışveriş merkezleri ve mağazalar</li>
              <li>Oteller ve konaklama tesisleri</li>
              <li>Hastaneler ve sağlık tesisleri</li>
              <li>Eğitim kurumları</li>
              <li>Apartman ve site yönetimleri</li>
              <li>Restoranlar ve kafeler</li>
            </ul>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Hizmet Sürecimiz
            </h3>
            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  1
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-1">İhtiyaç Analizi</h4>
                  <p className="text-dark-600">Binanızın veya işletmenizin ihtiyaçlarını değerlendiriyoruz</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  2
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-1">Ürün Önerisi</h4>
                  <p className="text-dark-600">Size en uygun ekipmanları öneriyoruz</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  3
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-1">Teklif Sunumu</h4>
                  <p className="text-dark-600">Detaylı ve şeffaf fiyat teklifi hazırlıyoruz</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  4
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-1">Teslimat ve Kurulum</h4>
                  <p className="text-dark-600">Ürünleri teslim edip gerekli kurulumları yapıyoruz</p>
                </div>
              </div>
            </div>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Servis Bölgelerimiz
            </h3>
            <p className="text-dark-600 leading-relaxed mb-8">
              [Şehir] ve tüm ilçelerinde yangın söndürme ekipmanları satış ve kurulum hizmeti vermekteyiz. Toplu alımlarda özel indirimlerden yararlanabilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-12 text-center">
            Neden İpek Yangın Söndürme?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Sertifikalı Ürünler</h3>
              <p className="text-dark-600 text-sm">TSE standartlarına uygun kaliteli ürünler</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-price-tag-3-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Uygun Fiyat</h3>
              <p className="text-dark-600 text-sm">Rekabetçi fiyatlar ve toplu alım indirimleri</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Hızlı Teslimat</h3>
              <p className="text-dark-600 text-sm">Stoklu ürünlerde aynı gün teslimat</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Profesyonel Destek</h3>
              <p className="text-dark-600 text-sm">Uzman danışmanlık ve satış sonrası destek</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-12 text-center">
            Sık Sorulan Sorular
          </h2>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-dark-50 rounded-lg p-6 border-l-4 border-primary-600">
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-3">
                  {faq.question}
                </h3>
                <p className="text-dark-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-6">
            Yangın Ekipmanları İçin Teklif Alın
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            İhtiyacınıza özel çözümler ve uygun fiyatlar için bizimle iletişime geçin
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/iletisim" 
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Teklif Al
            </Link>
            <a 
              href="https://wa.me/905XXXXXXXXX" 
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="bg-green-500 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-600 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-whatsapp-line"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FireEquipmentPage;
